import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  output,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CompanyTreeComponent } from 'src/app/app-common/components/company-tree/company-tree.component';
import { CompanyTreeSearchService } from 'src/app/app-common/services/company-tree-search.service';
import { ComponentsModule } from 'src/app/components/components.module';

@Component({
  selector: 'company-search-results',
  templateUrl: './company-search-results.component.html',
  styleUrl: './company-search-results.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ComponentsModule, CompanyTreeComponent, MatProgressSpinnerModule],
  host: {
    class: 'company-search-results',
  },
})
export class CompanySearchResultsComponent {
  protected readonly searchService = inject(CompanyTreeSearchService);

  readonly selectCompany = output<string>();

  protected readonly errorMessage = this.searchService.errorMessage;

  /**
   * The panel's own centered spinner still covers the first page; this one only
   * ever appears under results already on screen.
   */
  protected readonly loadingMore = computed(
    () =>
      this.searchService.loading() && this.searchService.results().length > 0,
  );

  /**
   * Never under the first-page spinner and never beside the error box: both
   * were regressions once, and both leave the query settled in a state the
   * copy would misdescribe.
   */
  protected readonly showEmptyState = computed(
    () =>
      !!this.searchService.query() &&
      !this.searchService.loading() &&
      !this.errorMessage() &&
      this.searchService.results().length === 0,
  );

  protected onScrollEnd(): void {
    this.searchService.load();
  }

  protected onRetry(): void {
    this.searchService.load();
  }
}
